<template>
<div class="information">
	 <leftnav class="fl" mkcode="b" itemcode="A-SCQBDT"></leftnav> 
	<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
		<govheader></govheader>
		<div class="index_left_centerpage">
			
			<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title">投资动态</span>
						</div>
						<!-- 筛选项开始 -->
				<div class="opport-screen-list1">
				<div class="spage-searchbox ">
					<ClueNav :searchtype="searchtype" ></ClueNav> 
					<dl class="opport-screen bdbe" >
						<dt class="fl">时间</dt>
						<dd class="fl">
							<span v-for="(item,index) in timelist" :key="'date'+index" @click="date = item.value;getlist()" :class="date == item.value?'current a-screen':'a-screen'">{{item.text}}</span>  
						</dd>
					</dl>
					<dl class="opport-screen bdbe">
						<dt class="fl">产业分类</dt>
						<dd class="fl">
							<span @click="notioncode = '';getlist()" :class="notioncode == ''?'current a-screen':'a-screen'">全部</span>
							<span v-for="(item,index) in meunlist" :key="item.notioncode+index" @click="notioncode = item.notioncode;getlist()" :class="notioncode == item.notioncode?'current a-screen':'a-screen'">{{item.notion}}</span>  
						</dd>
					</dl>
					<dl class="opport-screen bdbe" >
						<dt class="fl">关键词</dt>
						<dd class="fl">
							<span @click="keyid = '';getlist()" :class="keyid == ''?'current a-screen':'a-screen'">全部</span>
							<span v-for="(item,index) in commonkeylist" :key="'common'+index" @click="keyid = item.id;getlist()" :class="keyid == item.id?'current a-screen':'a-screen'">{{item.name}}</span>  
						</dd>
					</dl>
				</div>  
			</div>
			<!-- 筛选项结束 -->
			</div>
			
			
		<div class="whitebox information_box "> 
			<div class="enterparise_guide oh" style="width: 98%; ">
				<p class="fl">产业大脑为您找到<span class="searchnum">{{total}}</span>条匹配的实时情报信息</p>
			</div> 
		<div class="information_content">
			<div class="infornews" v-for="list in listdata" :key="list.id">
				<div @click="routerlinkid('/informationdetail',list.id,1)" class="infornews_d">
					<h5 class="title"><span class="fl info_title">{{list.title}}</span><span class="fr">{{list.publishTime}}</span></h5>
					<p>{{list.summary}}</p>
				</div> 
				<!-- <div class="keywords"  >
					<span  @click="tagrouter('/timeinforKey',7,'news',12,'扩大产能')">扩大产能</span>
				</div> -->
				<div class="keywords" v-show="list.keylist.length>0">
					<span v-for="item in list.keylist" :key="item.id" @click="tagrouter('/timeinforKey',7,'news',item.id,item.name)">{{item.name}}</span>
				</div>
			</div> 
		</div>
		<div class="centerpage1 company_pagelist" v-show="totalPage>1">
			<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
				v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
			</zpagenav>
		</div> 
		</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'information',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
			data(){return{ 
				userdata:{},title:"市场情报实时动态",notioncode:'',searchtype:6,//市场情报
				meunlist:[
					{notion:'高端装备',notioncode:'A01'},
					{notion:'汽车产业',notioncode:'A02'},
					{notion:'新一代信息技术',notioncode:'A03'},
					{notion:'新材料',notioncode:'A04'},
					{notion:'新能源',notioncode:'A05'},
					{notion:'生物医药',notioncode:'A06'},
					{notion:'环保',notioncode:'A07'}, ],
				meunindex:0,commonkeylist:[],
				keyid:'',
				listdata:[],
				timelist:[{text:'本月',value:'month'},{text:'本周',value:'week'},{text:'本日',value:'day'},],
				date:'month',  
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数 
				totalPage:1,
				maxPage:10,  //最大页数 
			}},
			created(){  
					this.$nextTick(() => {
							// 禁用右键
							document.oncontextmenu = new Function("event.returnValue=false");
							// 禁用选择
							document.onselectstart = new Function("event.returnValue=false");
					}); 
				this.userdata =this.getuseriformation();
			},
			mounted() { 
				document.getElementById('app').style.background = "#f0f3f5";
				this.bus.$emit('loading', true);
				if(this.userdata.edition<1){ 
					alert('您权限不足，不能访问该页面。'); 
					return;
				}
				this.getlist();
				this.getcomkeycode();
			},
			methods: {
				menutoggle(data){
					this.notioncode=data.notioncode;
					this.getlist();
				},
				keycodetoggle(id){
					this.keyid=id;
					this.getlist();
				},
			 getlist(pages){
					// console.log(notioncode); 
			 	var _this = this; 
			 	this.bus.$emit('loading', true); 
					var ajpage=1;
					if(pages){
						ajpage=pages;
					}
					this.page=ajpage;
					var notionja = this.splicing('notionList',this.notioncode);
					var keywordja = this.splicing('keywords',this.keyid);
					var dateja = this.splicing('date',this.date);
			 	var ajaxurl =this.$api.cyl.OCNNews.list()+'?page='+ajpage+notionja+keywordja+dateja;
			 	this.$axios.get(ajaxurl, {
			 		headers: {
			 			AuthToken: this.userdata.token
			 		}
			 	}).then(function(res) {
			 		console.log(ajaxurl,res);
			 		if (res.data.success) { 
							_this.listdata = res.data.list;
							for(var i=0;i<res.data.list.length;i++){
								_this.listdata[i].keylist=_this.taglistfun(res.data.list[i].keywordsText,res.data.list[i].keywords);
							}
							// console.log(_this.listdata);
							_this.totalPage=res.data.totalPage;
							_this.pageSize=res.data.pageSize;  
							_this.total=res.data.totalRecord; 
			 			_this.bus.$emit('loading', false); 
			 		} else {
			 			_this.tokenfailed(res.data.msg);
			 		}
			 	}).catch(function(error) {
			 		_this.bus.$emit('loading', false);
			 		// 请求失败处理 console.log(error);
			 	});
			 }, 
				getcomkeycode(){
					var ajaxurl =this.$api.cyl.OCNNews.keywords();  
					var _this = this; 
					this.$axios.get(ajaxurl, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
						// console.log(res.data);
						console.log('getcomkeycode',res.data)
						if (res.data.success) {   
							_this.commonkeylist=res.data.list;
							_this.bus.$emit('loading', false); 
						} else {
							_this.tokenfailed(res.data.msg);
						}
					}).catch(function(error) {
						_this.bus.$emit('loading', false);
						// 请求失败处理 console.log(error);
					}); 
				},
			
				pageHandler: function (page) {
					this.page = page; 
					this.getlist(page); 
				},
				
			},
	}
</script>

<style>
</style>
